import JsonSchema from '@evidentid/json-schema/interfaces/JsonSchema';
import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';

import { removeNonStandardSchemaFormat } from './removeNonStandardSchemaFormat';
import { standardizeCustomPropertySchema } from './standardizeCustomPropertySchema';

// TODO: rename it to standardizeCriterionSchema when we fully migrate to usage of this function
export function eidStandardizeCriterionSchema(
    schema: JsonSchema,
    customProperties?: CustomProperty[],
): JsonSchema {
    return removeNonStandardSchemaFormat(
        standardizeCustomPropertySchema(schema, customProperties),
    );
}
